import { render, staticRenderFns } from "./AdminUserFeedback.vue?vue&type=template&id=ca22d0a6&"
import script from "./AdminUserFeedback.vue?vue&type=script&lang=js&"
export * from "./AdminUserFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports